import { InputInlineWithLabel } from './InputInlineWithLabel'

export default InputInlineWithLabel
